// Romanian
export const ro = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portal client',
  'app.signOut':        'Deconectare',

  'login.email':        'E-mail',
  'login.password':     'Parolă',
  'login.signIn':       'Conectare',
  'login.signingIn':    'Se conectează…',
  'login.failed':       'Conectare eșuată',
  'login.newAccount':   'Nou pe Kardolive?',
  'login.createAccount':'Creează un cont gratuit →',

  'nav.workspace':      'Spațiu de lucru',
  'nav.templates':      'Șabloane',
  'nav.live':           'Live',
  'nav.rooms':          'Camere și chat',
  'nav.content':        'Conținut',
  'nav.developer':      'Dezvoltator',
  'nav.account':        'Cont',

  'nav.overview':       'Prezentare generală',
  'nav.projects':       'Proiecte',
  'nav.chat':           'Consolă chat',
  'nav.sessions':       'Sesiuni',
  'nav.streams':        'Transmisiuni live',
  'nav.studio':         'Studio',
  'nav.recordings':     'Înregistrări',
  'nav.apiKeys':        'Chei API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Tester de webhook',
  'nav.networkTest':    'Test de rețea',
  'nav.embed':          'Widget-uri încorporate',
  'nav.sdk':            'SDK-uri și documentație',
  'nav.docs':           'Documentație',
  'nav.analytics':      'Analiză',
  'nav.settings':       'Setări',

  'overview.welcome':       'Bine ai revenit, {name}',
  'overview.plan':          '{tenant} · plan {plan}',
  'overview.newStream':     'Transmisiune nouă',
  'overview.kpi.live':           'În direct acum',
  'overview.kpi.live.broadcasting': 'transmisiuni în desfășurare',
  'overview.kpi.live.nothing':    'nimic în direct',
  'overview.kpi.total':           'Total transmisiuni',
  'overview.kpi.total.sub':       'din toate timpurile',
  'overview.kpi.sessions':        'Sesiuni · 30 zile',
  'overview.kpi.sessions.sub':    'evenimente de publicare',
  'overview.kpi.recordings':      'Înregistrări',
  'overview.kpi.recordings.sub':  'gata de redare',
  'overview.recentStreams':       'Transmisiuni recente',
  'overview.recentSessions':      'Sesiuni recente',
  'overview.viewAll':             'Vezi toate →',
  'overview.empty.title':         'Încă nu există transmisiuni',
  'overview.empty.body':          'Creează prima ta transmisiune pentru a începe difuzarea.',
  'overview.empty.action':        'Creează transmisiune',
  'overview.noSessions':          'Încă nu există sesiuni',

  'status.live':        'ÎN DIRECT',
  'status.idle':        'INACTIV',
  'status.ended':       'ÎNCHEIAT',
  'status.archived':    'ARHIVAT',

  'common.save':        'Salvează',
  'common.cancel':      'Anulează',
  'common.delete':      'Șterge',
  'common.edit':        'Editează',
  'common.create':      'Creează',
  'common.confirm':     'Confirmă',
  'common.loading':     'Se încarcă…',
  'common.error':       'Eroare',
  'common.retry':       'Reîncearcă',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Salt la conținutul paginii",
  "nav.streamTemplates": "Șabloane de transmisie",
  "nav.boards": "Table interactive",
  "nav.menu": "Deschide navigarea",
  "nav.closeMenu": "Închide navigarea",
  "nav.scenarios": "Scenarii",
  "nav.premieres": "Premiere",
  "nav.clips": "Clipuri",
  "dashboard.account": "Cont",
  "dashboard.language": "Limbă",
  "dashboard.appearance": "Aspect",
  "nav.allStreams": "Toate transmisiile",
  "nav.destinations": "Destinații",
  "nav.ecommerce": "Comerț electronic",
  "nav.products": "Produse",
  "nav.services": "Servicii",
  "nav.collections": "Colecții",
  "nav.orders": "Comenzi",
  "nav.commerceSettings": "Setări comerciale",
  "nav.engagement": "Interacțiune",
  "theme.light": "Treci la modul luminos",
  "theme.dark": "Treci la modul întunecat",
  "role.owner": "Proprietar",
  "role.admin": "Administrator",
  "role.member": "Membru",
  "role.viewer": "Observator",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Active",
  "streams.archived": "Arhivate",
  "streams.monitor": "Monitorul surselor",
  "streams.create": "Creează o transmisie live",
  "streams.list": "Listă",
  "streams.grid": "Grilă",
  "streams.view": "Vizualizarea transmisiilor",
  "streams.searchLabel": "Caută evenimente",
  "streams.searchHint": "Caută după nume",
  "streams.solutionFilter": "Filtrează evenimentele după tip",
  "streams.statusFilter": "Filtrează evenimentele după stare",
  "streams.dateFilter": "Filtrează după data creării",
  "streams.allSolutions": "Toate tipurile",
  "streams.custom": "Configurare existentă sau personalizată",
  "streams.allStatuses": "Toate stările",
  "streams.anyTime": "Orice dată de creare",
  "streams.last7": "Create în ultimele 7 zile",
  "streams.last30": "Create în ultimele 30 de zile",
  "streams.count": "Se afișează {shown} din {total} evenimente",
  "streams.noMatch": "Niciun eveniment nu corespunde filtrelor.",
  "streams.clearFilters": "Șterge filtrele",
  "streams.refreshFailed": "Lista nu a putut fi actualizată",
  "streams.loadFailed": "Transmisiile nu au putut fi încărcate",
  "streams.stale": "Este afișată ultima listă încărcată. Stările s-ar putea să se fi schimbat.",
  "streams.connectionHint": "Verifică conexiunea și reîncarcă lista.",
  "streams.retrying": "Se reîncearcă…",
  "streams.retry": "Încearcă din nou",
  "streams.restoreFailed": "Transmisia nu a putut fi restaurată",
  "streams.restoreHint": "Verifică conexiunea și actualizează lista pentru a confirma starea înainte de a reîncerca.",
  "streams.unused": "Transmisii neutilizate: {count}",
  "streams.unusedHint": "Fără difuzări sau reluări. Arhivează-le pentru a ordona lista; nimic nu se șterge.",
  "streams.reviewArchive": "Verifică și arhivează",
  "streams.loading": "Se încarcă transmisiile…",
  "streams.archiveEmpty": "Nimic arhivat. Transmisiile arhivate și reluările lor rămân aici până le restaurezi.",
  "streams.restore": "Restaurează",
  "streams.firstTitle": "Creează prima transmisie",
  "streams.firstBody": "Alege o configurare pentru vânzări, cursuri sau servicii ori începe de la zero. Transmite din browser, de pe telefon sau prin OBS.",
  "streams.blank": "Transmisie goală",
  "streams.broadcasts": "Difuzări: {count}",
  "streams.replays": "Reluări: {count}",
  "streams.sessions": "Sesiuni: {count}",
  "streams.recordings": "Înregistrări: {count}",
  "streams.mode.BROADCAST": "Difuzare",
  "streams.mode.LOW_LATENCY": "Latență redusă",
  "streams.mode.REALTIME": "Timp real",
  "streams.key": "Cheie",
  "streams.archiveTitle": "Arhivează transmisiile neutilizate",
  "streams.archiveHint": "Aceste transmisii nu au fost niciodată difuzate. Le poți restaura oricând din fila Arhivate.",
  "streams.archiveFailed": "Nu s-au putut arhiva {count} transmisii; este posibil să fi început difuzarea. Celelalte au fost arhivate.",
  "streams.archiving": "Se arhivează…",
  "streams.archiveCount": "Arhivează {count}",
  "streamType.webinar": "Webinare și lansări de afaceri",
  "streamType.classroom": "Cursuri și meditații",
  "streamType.training": "Formare corporativă",
  "streamType.conference": "Conferințe și expoziții",
  "streamType.shopping": "Cumpărături live",
  "streamType.auction": "Licitații live",
  "streamType.consultation": "Consultații private",
  "streamType.creator": "Creatori și comunități live",
  "streamType.audio": "Camere audio și podcasturi",
  "streamType.sports": "Sport și sporturi electronice",
  "streamType.performance": "Concerte și spectacole",
  "streamType.community": "Slujbe și strângeri de fonduri",
  "streamType.tour": "Tururi și demonstrații",
  "streamType.fitness": "Fitness și ateliere",
  "streamType.public-meeting": "Știri și ședințe publice",
  "streamType.continuous": "Canale continue și camere",
  "streams.close": "Închide",
};
